import BaseListagem from "components/BaseListagem";
import ClassificacaoRequisito from "model/auditoria5s/ClassificacaoRequisito";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import RequisitoAuditoriaService from "service/auditoria5s/RequisitoAuditoriaService";
import { IdMatchModeOptions, TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const requisitoAuditoriaService = new RequisitoAuditoriaService();

export default function RequisitoAuditoriaListagem() {

    const [classificacoesRequisito, setClassificacoesRequisito] = useState<ClassificacaoRequisito[]>([]);

    useEffect(()=>{
        requisitoAuditoriaService.classificacaoes().then((data) => {
            setClassificacoesRequisito(data);
        }).catch((err) => {
            console.error(err);
        });
    },[])

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        descricao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        classificacaoRequisito: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }
    const classificacaoFilterField = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={classificacoesRequisito} filter
            onChange={(e) => options.filterCallback(e.value)} 
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={requisitoAuditoriaService} urlService="/requisitoAuditoria" tituloPagina={'Requisitos'} defaultFilters={defaultFilters} showClearFilterButton nome="requisitoAuditoria">
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}/>
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="classificacaoRequisito.nome" header="Classificação" filterField="classificacaoRequisito" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={classificacaoFilterField} />
        </BaseListagem>
    )
}
